'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_SignedDocumentsHistoryPage$() {
}
export { $c_Lpresto_SignedDocumentsHistoryPage$ as $c_Lpresto_SignedDocumentsHistoryPage$ };
$p = $c_Lpresto_SignedDocumentsHistoryPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_SignedDocumentsHistoryPage$;
/** @constructor */
function $h_Lpresto_SignedDocumentsHistoryPage$() {
}
export { $h_Lpresto_SignedDocumentsHistoryPage$ as $h_Lpresto_SignedDocumentsHistoryPage$ };
$h_Lpresto_SignedDocumentsHistoryPage$.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return 942333127;
});
$p.l = (function() {
  return "SignedDocumentsHistoryPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "SignedDocumentsHistoryPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dw = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().Yb);
});
var $d_Lpresto_SignedDocumentsHistoryPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_SignedDocumentsHistoryPage$, "presto.SignedDocumentsHistoryPage$", ({
  R4: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_SignedDocumentsHistoryPage$ as $d_Lpresto_SignedDocumentsHistoryPage$ };
var $n_Lpresto_SignedDocumentsHistoryPage$;
function $m_Lpresto_SignedDocumentsHistoryPage$() {
  if ((!$n_Lpresto_SignedDocumentsHistoryPage$)) {
    $n_Lpresto_SignedDocumentsHistoryPage$ = new $c_Lpresto_SignedDocumentsHistoryPage$();
  }
  return $n_Lpresto_SignedDocumentsHistoryPage$;
}
export { $m_Lpresto_SignedDocumentsHistoryPage$ as $m_Lpresto_SignedDocumentsHistoryPage$ };
//# sourceMappingURL=presto.-Signed-Documents-History-Page$.js.map
